export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '57e9c375-2dc4-44e8-a7e7-cfe46b3e5d9a';
export const MODAL_CLOSE_SEC = 2.5;
